// Pill chip. `color` drives the dot / solid fill via --chip-color.
export default function Chip({ variant = 'outline', color, dot = false, active = false, as: Tag = 'span', className = '', style, children, ...rest }) {
  const styleVars = color ? { '--chip-color': color, ...style } : style
  return (
    <Tag className={`cn-chip cn-chip--${variant} ${className}`.trim()} data-active={active ? 'true' : 'false'} style={styleVars} {...rest}>
      {dot && <span className="cn-chip-dot" />}
      {children}
    </Tag>
  )
}
